import { z } from "zod";
import { zWorldId, zWorldState, zWorldDepiction, zWorldCharacterPosition } from "./worlds";
import { zWorldEventReceipt } from "./worldPersistence";

/** Omitted means the current frontier; null means the baseline before recorded events. */
export const zWorldMomentPosition = z
  .object({
    eventId: zWorldId.nullable(),
    frameId: zWorldId.optional(),
  })
  .strict()
  .refine((value) => !value.frameId || !!value.eventId, "A depicted frame needs its recording event.");
export type WorldMomentPosition = z.infer<typeof zWorldMomentPosition>;
export const zWorldMoment = z.object({
  state: zWorldState,
  position: zWorldMomentPosition.optional(),
  label: z.string(),
  historyId: z.string(),
  events: z.array(zWorldEventReceipt),
  depictions: z.array(zWorldDepiction),
  warnings: z.array(z.string()),
  characterPositions: z.array(zWorldCharacterPosition).optional(),
});
export type WorldMoment = z.infer<typeof zWorldMoment>;
